import { closeSnackBar, InitSnackBarAction, openSnackBar } from "./action";
import { Dispatch } from "redux";

export function OpenSnackBarWithResultSuccess(message:string){
    return (dispatch: Dispatch<InitSnackBarAction>)=>{
      dispatch(openSnackBar(true,true,message));  
  }
}

export function OpenSnackBarWithResultFail(message:string){
  return (dispatch: Dispatch<InitSnackBarAction>)=>{
    dispatch(openSnackBar(true,false,message));  
}
}



export function CloseSnackBar(){
  return (dispatch: Dispatch<InitSnackBarAction>)=>{
    dispatch(closeSnackBar(false,false,""));  
}
}